function fmtClock(ms: number): string {
  const d = new Date(ms);
  return d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  });
}

function fmtElapsed(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
}

const SPEEDS = [1, 2, 4, 8];

export function SessionScrubber({
  index,
  maxIndex,
  isPlaying,
  onToggle,
  onScrub,
  onSkip,
  speed,
  onSpeed,
  startMs,
}: {
  index: number;
  maxIndex: number;
  isPlaying: boolean;
  onToggle: () => void;
  onScrub: (i: number) => void;
  onSkip: (delta: number) => void;
  speed: number;
  onSpeed: (s: number) => void;
  startMs: number;
}) {
  const currentMs = startMs + index * 1000;
  return (
    <div className="scrubber">
      <div className="scrubber-controls">
        <button className="scrub-btn" onClick={() => onSkip(-10)} title="Back 10s" aria-label="Back 10 seconds">
          <i className="ti ti-rewind-backward-10" aria-hidden="true" />
        </button>
        <button className="scrub-btn scrub-play" onClick={onToggle} aria-label={isPlaying ? "Pause" : "Play"}>
          <i className={isPlaying ? "ti ti-player-pause-filled" : "ti ti-player-play-filled"} aria-hidden="true" />
        </button>
        <button className="scrub-btn" onClick={() => onSkip(10)} title="Forward 10s" aria-label="Forward 10 seconds">
          <i className="ti ti-rewind-forward-10" aria-hidden="true" />
        </button>

        <span className="scrub-time">{fmtClock(currentMs)}</span>

        <input
          className="scrub-range"
          type="range"
          min={0}
          max={maxIndex}
          step={1}
          value={index}
          onChange={(e) => onScrub(Number(e.target.value))}
        />

        <span className="scrub-elapsed">
          {fmtElapsed(index)} / {fmtElapsed(maxIndex)}
        </span>

        <select
          className="scrub-speed"
          value={speed}
          onChange={(e) => onSpeed(Number(e.target.value))}
          aria-label="Playback speed"
        >
          {SPEEDS.map((s) => (
            <option key={s} value={s}>
              {s}×
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
